import { useCallback, useState } from 'react';
import { addDays, isAfter } from 'date-fns';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

const LOCAL_STORAGE_NAMESPACE = 'nudge-bundle-users';

type FlagDismissed = [
	{ hasBeenDismissed: boolean },
	{ dismiss: () => void; canReShowFlag: () => boolean },
];
const storage = createLocalStorageProvider(LOCAL_STORAGE_NAMESPACE);
const storageKey = 'flag-dismissed';
const ADD_DAYS = 14;

export const useFlagDismissed = (): FlagDismissed => {
	const [hasBeenDismissed, setHasBeenDismissed] = useState<boolean>(
		Boolean(storage.get(storageKey)),
	);

	const dismiss = useCallback(() => {
		setHasBeenDismissed(true);
		storage.set(storageKey, Date.now());
	}, [setHasBeenDismissed]);

	const canReShowFlag = useCallback(() => {
		let canShowFlag = false;
		if (hasBeenDismissed) {
			const dismissDate = storage.get(storageKey);
			if (isAfter(Date.now(), addDays(dismissDate, ADD_DAYS))) {
				canShowFlag = true;
			}
		}
		return canShowFlag;
	}, [hasBeenDismissed]);

	return [
		{
			hasBeenDismissed,
		},
		{
			dismiss,
			canReShowFlag,
		},
	];
};
